module.exports = __webpack_public_path__ + "static/media/bid-stone.984da752.svg";